<template>
  <div class="section-content">
    end of the story
    <div class="landing-links">
        <div class="landing-link">
          <div class="link-item" @click="$store.dispatch('next')">
            explore the land
          </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss">
.landing-links {
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  .landing-link {
    display: flex;
    flex-direction: column;
    .link-item {
      border-bottom: solid 2px #9a6969;
      margin-bottom: 8px;
      cursor: pointer;
      align-self: center;
      font-family: Rubik-Medium;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #18333c;
    }
  }
}
</style>
